import { Injectable } from '@angular/core';
import { IErrorMessages } from 'bi-interfaces';

@Injectable({
  providedIn: 'root'
})
export class ErrorDetailsService implements IErrorMessages {
  Title!: string;
  Details!: string;
  Link!: string;
  Parameter!: string;
  Id!: number;
  Type!: number;
  showErrorMsg = false;
  ErrorMessagesQueue!: IErrorMessages[];
  constructor() { }

  PushErrorMessages(error: IErrorMessages) {
    if (this.ErrorMessagesQueue?.length) this.ErrorMessagesQueue.push(error);
    else this.ErrorMessagesQueue = [error];
  }
}
